<template>
  <div class="block">
    <div class="reorder nested">
      <a href="#" v-on:click="$emit('moveDown', data)" class="move-up">&uarr;</a>
      <a href="#" v-on:click="$emit('moveUp', data)" class="move-down">&darr;</a>
    </div>
    <a href="#" v-on:click="$emit('deleteBlock', data)" class="delete nested">x</a>
    <label class="underline nested">Image block</label>
    <div class="field nested">
      <label>Style options</label>
      <div class="control">
        <select v-model="data.classNames" @change="update" multiple>
          <option value="image-left">Left</option>
          <option value="image-right">Right</option>
          <option value="centered">Centered</option>
          <option value="full-width">Full width</option>
          <option value="full-screen">Fullscreen</option>
          <option value="fixed-bg">Fixed background</option>
          <option value="gallery">Gallery</option>
          <option value="double-image">Side-by-side images</option>
          <option value="logo">Small logo</option>
        </select>
      </div>
    </div>
    <div class="field">
      <label class="label">Background colour</label>
      <div class="control">
        <input class="input" type="text" placeholder="#cccccc" v-model="data.styles_background_colour" />
      </div>
    </div>
    <div class="field">
      <label class="nested">Image/s</label>
      <div class="control image-wrapper">
        <figure v-if="data.images" class="image" v-for="image in data.images">
          <a href="#" v-on:click="deleteImage(image.id)" class="delete">x</a>
          <img v-if="image" :src="image.url" />
          <input type="text" placeholder="Image caption" v-model="image.caption" @change="update" />
        </figure>
        <file-uploader v-if="!singleOnly || (singleOnly && (!data.images || data.images.length < 1))" @url="onUpload" />
      </div>
    </div>
  </div>
</template>

<script>
import { firestore } from '../main'
import _ from 'lodash'
import crypto from 'crypto'
import FileUploader from '@/components/FileUploader'

export default {
  name: 'Edit-ImageBlock',
  props: {
    singleOnly: false,
    data: {
      type: Object,
      default() {
        return {
          classNames: []
        }
      }
    },
    computed: {
      dataReceived: function () {
        const data = this.data.classNames || [];
        return data;
      }
    }
  },
  components: {
    FileUploader
  },
  methods: {
    onUpload(url, id) {
      if (!this.data.images) this.data.images = []
      let index = _.findIndex(this.data.images, { 'id': id })
      if (index < 0) {
        this.data.images.push({ id: crypto.randomBytes(16).toString("hex"), url: url })
      } else {
        this.$set(this.data.images, index, url)
      }
      this.update()
    },
    deleteImage: function(id) {
      if (confirm('Are you sure you want to delete this?')) {
        let index = _.findIndex(this.data.images, { 'id': id })
        this.$delete(this.data.images, index)
        this.update()
      }
    },
    update: function() {
      this.$emit('updateBlock', this.data)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .image-wrapper {
    display: flex;
    flex-wrap: wrap;
    margin-right: -2rem;
  }
  .image-wrapper > * {
    margin: 0 2rem 2rem 0;
    min-width: 16rem;
    max-width: 30%;
    flex: 1;
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// src/components/Edit-ImageBlock.vue